import React from "react";
import styled from "@emotion/styled";
import { TabInfo } from "./TabInfo";
import { VerticalGap } from "../styled/gaps";
import { HolidaysList } from "./HolidaysList";
import { AddHoliday } from "./AddHoliday";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  padding: 20px 30px;
`;

const Holidays = (props) => {
  return (
    <Container>
      <TabInfo
        header={"Holidays"}
        desc={`This page displays the information about your Holidays. You can add upcoming holidays, days which will not be shown to clients`}
        editIcon={false}
      />
      <VerticalGap size={"20px"} /> <HolidaysList />
      <VerticalGap size={"20px"} />
      <AddHoliday />
    </Container>
  );
};

export { Holidays };
